import { render } from "./gsrbr020401.vue?vue&type=template&id=0d0181eb&scoped=true"
import script from "./gsrbr020401.vue?vue&type=script&lang=js"
export * from "./gsrbr020401.vue?vue&type=script&lang=js"

import "./gsrbr020401.vue?vue&type=style&index=0&id=0d0181eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0181eb"]])

export default __exports__